import { render, staticRenderFns } from "./priClientProfile.vue?vue&type=template&id=6bf10fbc&scoped=true"
import script from "./priClientProfile.vue?vue&type=script&lang=js"
export * from "./priClientProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf10fbc",
  null
  
)

export default component.exports